module.exports = __webpack_public_path__ + "img/Dantam Makeover 06.5e36356f.jpg";